import {DossierDto, IDossierWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";

@Injectable()
export class DetailServeurResultatsResolver implements Resolve<DossierDto> {

  constructor(private dossierClient: IDossierWebServiceClient) {
  }

  resolve(activeRoute: ActivatedRouteSnapshot) {
    let id: number = Number(activeRoute.paramMap.get('id'));
    return this.dossierClient.findById(id);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/detail-resultat/detail-resultat.resolver.ts